<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
                Overview
            </h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">A gift pyramid is a tool that helps an organization determine the number of donors, prospects, and gifts needed to raise a specific amount of money. A gift pyramid will also help an organization prioritize how it spends its time cultivating and soliciting donors. Donors/gifts at the top of the pyramid will be larger in size, but only a few of them will be needed. The higher-level donors/gifts should also fund a majority of your organization's fundraising goal. Donors/gifts at the bottom of the pyramid will be smaller, but more donors will be needed.</p>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]"> <span class="font-bold"> Prospect: Donor Ratio </span> - A prospect-to-donor ratio will help your organization understand the number of prospects it needs for every gift it expects to close. Using the maturity chart below, determine the prospect-todonor ratio your organization will use. For organizations with more mature donor constituencies, the prospect-todonor ratio is lower. For organizations with less mature donor constituencies, the prospect-to-donor ratio is higher.</p>

            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
              Prospect to Donor Chart
            </h3>

            <table class="border border-[#414141] border-collapse m-6 text-[14px] leading-[22px]">
            <tbody>
              <tr class="bg-[#F5F6FAB3] text-[#00423D]">
                <th class="font-semibold border border-[#414141] p-3 text-center">Maturity level</th>
                <th class="font-semibold border border-[#414141] p-3 text-center">Common donor characteristics</th>
                <th class="font-semibold border border-[#414141] p-3 text-center w-[150px]">Prospect-to donor ratio</th>
              </tr>
              <tr>
                <td class="border border-[#414141] text-[#414141] p-3">Low</td>
                <td class="border border-[#414141] text-[#414141] p-3">
                  <ul class="list-disc pl-5">
                    <li>Small donor base giving small gifts</li>
                    <li class="mt-2">Organization does not know many of these donors</li>
                  </ul>
                </td>
                <td class="border border-[#414141] text-center p-3">5:1</td>
              </tr>
              <tr>
                <td class="border border-[#414141] p-3">Average</td>
                <td class="border border-[#414141] p-3">
                  <ul class="list-disc pl-5">
                    <li>Some mid and large donors</li>
                    <li class="mt-2">Donors have some engagement</li>
                    <li class="mt-2">Donor cultivation in progress</li>
                  </ul>
                </td>
                <td class="border border-[#414141] text-center p-3">4:1</td>
              </tr>
              <tr>
                <td class="border border-[#414141] p-3">High</td>
                <td class="border border-[#414141] p-3">
                  <ul class="list-disc pl-5">
                    <li>Many large donors and long-time recurring donors</li>
                    <li class="mt-2">Donors know the organization well</li>
                  </ul>
                </td>
                <td class="border border-[#414141] text-center p-3">3:1</td>
              </tr>
            </tbody>
          </table>

        </div>
    </div>
</template>

<script setup>
import { inject, onMounted } from 'vue';
import { useStepValidation } from '@/composables/useStepValidation';
const addToaster = inject('addToaster');

onMounted(() => {
  if (addToaster) {
    addToaster({
      title: 'Well done!',
      resourceName: 'Case for support',
      resourceLink: '#'
    });
    addToaster({
      title: 'Well done!',
      resourceName: 'Case for Support Narrative',
      resourceLink: '#'
    });
  }
});

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 